// 登录、注册、忘记密码
const login = {
  anJun: {
    zh: '安骏跨境物流系统',
    en: '',
    pu: 'Sistema Logístico Cross Border de Anjun'
  },
  anjunKD: {
    zh: '安骏快递系统',
    en: '',
    pu: 'Sistema Anjun Express'
  },
  WELCOME: {
    zh: 'WELCOME',
    en: 'WELCOME',
    pu: 'Bem-vindo'
  },
  platformSubtitle: {
    zh: '欢迎回到安骏快递管理平台',
    en: 'Welcome back to Anjun Express Management Platform',
    pu: 'Bem-vindo de volta à plataforma de gestão Anjun Express'
  },
  login: {
    zh: '登录',
    en: '',
    pu: 'Fazer login'
  },
  ssoLogin: {
    zh: '用户中心登录',
    en: 'User Center Login',
    pu: 'Login do Centro de Usuários'
  },
  welcome: {
    zh: '欢迎',
    en: '',
    pu: 'Bem-vindo'
  },
  email: {
    zh: '邮箱',
    en: '',
    pu: 'Email'
  },
  emailPrompt: {
    zh: '请输入邮箱',
    en: '',
    pu: 'Por favor digite o email'
  },
  password: {
    zh: '密码',
    en: '',
    pu: 'Senha'
  },
  passwordPrompt: {
    zh: '请输入密码',
    en: '',
    pu: 'Por favor digite a senha'
  },
  loginCode: {
    zh: '验证码',
    en: '',
    pu: 'Código de verificaçaõ'
  },
  inputPrompt: {
    zh: '请输入内容',
    en: '',
    pu: 'Por favor digite conteúdo'
  },
  isForget: {
    zh: '忘记密码？',
    en: '',
    pu: 'Esqueceu a senha?'
  },
  isRegistered1: {
    zh: '第一次登录？点击',
    en: '',
    pu: 'Login pela primeira vez? Clique'
  }, // 第一次登录？点击 注册
  isRegistered2: {
    zh: '注册',
    en: '',
    pu: 'Cadastrar'
  },
  getCode: {
    zh: '获取',
    en: '',
    pu: 'Obter'
  },
  ss: {
    zh: '秒',
    en: '',
    pu: 'segundos'
  },
  toObtain: {
    zh: '重新获取',
    en: '',
    pu: 'obter novamente'
  },
  raLogin: {
    zh: '立即登录',
    en: '',
    pu: 'Fazer login agora'
  },
  // 已有账号，立即登陆
  toLoginPrompt: {
    zh: '已有账号，立即',
    en: '',
    pu: 'Já tenho conta, login de imediato'
  },
  forget: {
    zh: '忘记密码',
    en: '',
    pu: 'Esqueci a senha'
  },
  // 登录时弱密码提示
  pwdTipTop: {
    zh: '提示',
    en: 'tips',
    pu: 'Dica'
  },
  pwdTipContent: {
    zh: '当前密码为弱密码，请更换密码',
    en: '',
    pu: 'A senha atual é fraca, por favor mude-a'
  },
  confirm: {
    zh: '确认',
    en: '',
    pu: 'confirmar'
  },
  changePwd: {
    zh: '修改密码',
    en: 'changePwd',
    pu: 'alterar a senha'
  },
  lginOut: {
    zh: '退出登录',
    en: 'lginOut',
    pu: 'logout'
  },
  inputNumber: {
    zh: '请输入账号',
    en: '',
    pu: 'Por favor digite o número de conta'
  },
  inputRightCode: {
    zh: '请输入正确的验证码',
    en: '',
    pu: 'Por favor digite o código de verificação correto'
  },
  quanxian: {
    zh: '将要跳转的页面没有权限访问',
    en: '',
    pu: 'A página a ser acessada não tem permissão de acesso'
  },
  verifyBeforeLogin: {
    zh: '请验证后再登录',
    en: 'Please verify before logging in',
    pu: 'Por favor, verifique antes de fazer login'
  },
  // 飞书登录
  feishuLogin: {
    zh: '飞书登录',
    en: 'Feishu Login',
    pu: 'Login com Feishu'
  },
  enterpriseLoginDivider: {
    zh: '或使用企业身份登录',
    en: 'Or sign in with enterprise identity',
    pu: 'Ou entre com identidade corporativa'
  },
  feishuLoginTips: {
    zh: '点击跳转到飞书授权页面',
    en: 'Click to redirect to Feishu authorization page',
    pu: 'Clique para redirecionar para a página de autorização Feishu'
  },
  feishuAppIdNotConfig: {
    zh: '飞书应用ID未配置，请联系管理员',
    en: 'Feishu App ID not configured, please contact administrator',
    pu: 'ID do aplicativo Feishu não configurado, entre em contato com o administrador'
  },
  loggingIn: {
    zh: '正在登录...',
    en: 'Logging in...',
    pu: 'Fazendo login...'
  },
  loginSuccess: {
    zh: '登录成功',
    en: 'Login successful',
    pu: 'Login realizado com sucesso'
  },
  feishuLoginFailed: {
    zh: '飞书登录失败',
    en: 'Feishu login failed',
    pu: 'Falha no login Feishu'
  },
  // 个人中心
  personalCenter: {
    zh: '个人中心',
    en: 'Personal Center',
    pu: 'Centro Pessoal'
  },
  username: {
    zh: '账号',
    en: 'Username',
    pu: 'Conta'
  },
  realName: {
    zh: '真实姓名',
    en: 'Real Name',
    pu: 'Nome Real'
  },
  phone: {
    zh: '手机号',
    en: 'Phone',
    pu: 'Telefone'
  },
  position: {
    zh: '职位',
    en: 'Position',
    pu: 'Cargo'
  },
  orgName: {
    zh: '部门名称',
    en: 'Department Name',
    pu: 'Nome do Departamento'
  },
  siteName: {
    zh: '网点名称',
    en: 'Site Name',
    pu: 'Nome do Site'
  },
  cpf: {
    zh: 'CPF',
    en: 'CPF',
    pu: 'CPF'
  },
  feishuStatus: {
    zh: '飞书状态',
    en: 'Feishu Status',
    pu: 'Status do Feishu'
  },
  feishuBound: {
    zh: '已绑定飞书',
    en: 'Feishu Bound',
    pu: 'Feishu Vinculado'
  },
  feishuNotBound: {
    zh: '未绑定飞书',
    en: 'Feishu Not Bound',
    pu: 'Feishu Não Vinculado'
  },
  bindFeishu: {
    zh: '绑定飞书',
    en: 'Bind Feishu',
    pu: 'Vincular Feishu'
  },
  unbindFeishu: {
    zh: '解绑飞书',
    en: 'Unbind Feishu',
    pu: 'Desvincular Feishu'
  },
  validaCode: {
    zh: '验证码',
    en: 'Verification Code',
    pu: 'Código de Verificação'
  },
  inputValidaCode: {
    zh: '请输入验证码',
    en: 'Please enter verification code',
    pu: 'Por favor digite o código de verificação'
  },
  sendCode: {
    zh: '发送验证码',
    en: 'Send Code',
    pu: 'Enviar Código'
  },
  sendCodeSuccess: {
    zh: '验证码发送成功',
    en: 'Verification code sent successfully',
    pu: 'Código de verificação enviado com sucesso'
  },
  sendCodeFailed: {
    zh: '验证码发送失败',
    en: 'Failed to send verification code',
    pu: 'Falha ao enviar código de verificação'
  },
  codeLengthError: {
    zh: '验证码长度为6位',
    en: 'Verification code must be 6 digits',
    pu: 'O código de verificação deve ter 6 dígitos'
  },
  bindSuccess: {
    zh: '绑定成功',
    en: 'Bind successful',
    pu: 'Vinculação bem-sucedida'
  },
  bindFailed: {
    zh: '绑定失败',
    en: 'Bind failed',
    pu: 'Falha na vinculação'
  },
  unbindSuccess: {
    zh: '解绑成功',
    en: 'Unbind successful',
    pu: 'Desvinculação bem-sucedida'
  },
  unbindFailed: {
    zh: '解绑失败',
    en: 'Unbind failed',
    pu: 'Falha na desvinculação'
  },
  getUserInfoFailed: {
    zh: '获取用户信息失败',
    en: 'Failed to get user info',
    pu: 'Falha ao obter informações do usuário'
  },
  popupBlocked: {
    zh: '弹窗被拦截，请允许弹窗后重试',
    en: 'Popup blocked, please allow popups and try again',
    pu: 'Pop-up bloqueado, permita pop-ups e tente novamente'
  },
  processing: {
    zh: '正在处理...',
    en: 'Processing...',
    pu: 'Processando...'
  },
  codeSent: {
    zh: '授权码已发送',
    en: 'Authorization code sent',
    pu: 'Código de autorização enviado'
  },
  closingWindow: {
    zh: '窗口即将关闭',
    en: 'Window will close soon',
    pu: 'A janela fechará em breve'
  },
  invalidCode: {
    zh: '无效的授权码',
    en: 'Invalid authorization code',
    pu: 'Código de autorização inválido'
  },
  unbindWarning: {
    zh: '解绑后将无法使用飞书账号登录系统，请谨慎操作',
    en: 'After unbinding, you will not be able to login with Feishu account, please proceed with caution',
    pu: 'Após desvincular, você não poderá fazer login com a conta Feishu, por favor prossiga com cautela'
  },
  basicInfo: {
    zh: '基本信息',
    en: 'Basic Information',
    pu: 'Informações Básicas'
  },
  feishuBoundDesc: {
    zh: '您已成功绑定飞书账号，可以使用飞书快捷登录',
    en: 'You have successfully bound your Feishu account, you can use Feishu for quick login',
    pu: 'Você vinculou com sucesso sua conta Feishu, pode usar o Feishu para login rápido'
  },
  feishuNotBoundDesc: {
    zh: '绑定飞书账号后，可以使用飞书快捷登录系统',
    en: 'After binding Feishu account, you can use Feishu for quick login',
    pu: 'Após vincular a conta Feishu, você pode usar o Feishu para login rápido'
  },
  // 飞书绑定页面
  feishuBindTitle: {
    zh: '绑定飞书账号',
    en: 'Bind Feishu Account',
    pu: 'Vincular Conta Feishu'
  },
  feishuBindSubtitle: {
    zh: '请输入您的系统账号和密码以完成绑定',
    en: 'Please enter your system account and password to complete binding',
    pu: 'Por favor, insira sua conta do sistema e senha para concluir a vinculação'
  },
  confirmBind: {
    zh: '确认绑定',
    en: 'Confirm Bind',
    pu: 'Confirmar Vinculação'
  },
  backToLogin: {
    zh: '返回登录',
    en: 'Back to Login',
    pu: 'Voltar ao Login'
  },
  invalidBindCode: {
    zh: '无效的绑定验证码',
    en: 'Invalid bind verification code',
    pu: 'Código de verificação de vinculação inválido'
  },
  accountBindRequired: {
    zh: '该飞书账号未绑定系统账号，请先绑定',
    en: 'This Feishu account is not bound to a system account, please bind first',
    pu: 'Esta conta Feishu não está vinculada a uma conta do sistema, por favor vincule primeiro'
  },
  brandSlogan: {
    zh: '安骏快递管理系统',
    en: 'Anjun Express Management System',
    pu: 'Sistema de Gestão Anjun Express'
  },
  brandName: {
    zh: '安骏',
    en: 'Anjun',
    pu: 'Anjun'
  },
  STREET_ERROR: {
    zh: '街道错误',
    en: 'Street error',
    pu: 'Rua incorreta'
  },
  HOUSE_NUMBER_ERROR: {
    zh: '门牌号错误',
    en: 'House number error',
    pu: 'Número incorreta'
  },
  HOUSE_NUMBER_MISSING: {
    zh: '缺少门牌号',
    en: 'House number missing',
    pu: 'Número ausente'
  },
  OTHER: {
    zh: '其它',
    en: 'Other',
    pu: 'Outros'
  },
  addressIssueType: {
    zh: '地址问题类型',
    en: 'Address Issue Type',
    pu: 'Tipo de Problema de Endereço'
  },
  insufficientPrepaidFunds: {
    zh: '预存资金不足',
    en: 'Insufficient Prepaid Funds',
    pu: 'Fundos Pré-pagos Insuficientes'
  },

  creationMethod: {
    zh: '创建方式',
    en: 'Creation Method',
    pu: 'Método de Criação'
  },
  inviter: {
    zh: '邀请人',
    en: 'Inviter',
    pu: 'Convidante'
  },
  invitationRegistration: {
    zh: '邀请注册',
    en: 'Invitation Registration',
    pu: 'Registro por Convite'
  },
  invitationRegistrationInstruction: {
    zh: '发送以下链接或二维码给客户，客户访问链接或扫描二维码即可进行账号注册',
    en: 'Send the following link or QR code to the customer. The customer can access the link or scan the QR code to register an account.',
    pu: 'Envie o seguinte link ou código QR para o cliente. O cliente pode acessar o link ou escanear o código QR para registrar uma conta.'
  },
  copyLink: {
    zh: '复制链接',
    en: 'Copy Link',
    pu: 'Copiar Link'
  },
  copyQrCode: {
    zh: '复制二维码',
    en: 'Copy QR Code',
    pu: 'Copiar Código QR'
  },
  encryptedTamperProofNotice: {
    zh: '提示：该链接、二维码已关联当前系统登录账号，已加密、防篡改',
    en: 'Note: This link and QR code are associated with the current system login account, encrypted, and tamper-proof.',
    pu: 'Nota: Este link e código QR estão associados à conta de login atual do sistema, criptografados e à prova de adulteração.'
  },
  copyFailed: {
    zh: '复制失败',
    en: 'Copy Failed',
    pu: 'Falha ao Copiar'
  },
  qrCodeNotGenerated: {
    zh: '二维码未生成',
    en: 'QR Code Not Generated',
    pu: 'Código QR Não Gerado'
  },
  qrCodeCopiedReadyToPaste: {
    zh: '二维码已复制，可直接粘贴',
    en: 'QR Code copied, ready to paste',
    pu: 'Código QR copiado, pronto para colar'
  },
  copyFailedSaveImageManually: {
    zh: '复制失败，请右键保存图片',
    en: 'Copy failed, please right-click to save the image',
    pu: 'Falha ao copiar, clique com o botão direito para salvar a imagem'
  },
  browserNoImageCopySupport: {
    zh: '当前浏览器不支持图片复制，请右键保存二维码',
    en: 'Current browser does not support image copying, please right-click to save the QR code',
    pu: 'O navegador atual não suporta cópia de imagem, clique com o botão direito para salvar o código QR'
  },
  connectingSso: {
    zh: '正在连接认证中心',
    en: 'Connecting to SSO center',
    pu: 'Conectando ao centro SSO'
  },
  verifyingTicket: {
    zh: '正在验证登录凭据',
    en: 'Verifying login credentials',
    pu: 'Verificando credenciais de login'
  },
  gettingSsoUrl: {
    zh: '正在获取认证地址',
    en: 'Getting authentication address',
    pu: 'Obtendo endereço de autenticação'
  },
  processingRequest: {
    zh: '请稍候，我们正在为您处理登录请求...',
    en: 'Please wait, we are processing your login request...',
    pu: 'Aguarde, estamos processando sua solicitação de login...'
  },
  redirecting: {
    zh: '正在为您跳转...',
    en: 'Redirecting...',
    pu: 'Redirecionando...'
  }
};

// POD有效性验证 - 指定单号审核
const podVerification = {
  tabDesignatedAudit: {
    zh: '指定单号审核',
    en: 'Designated Waybill Audit',
    pu: 'Auditoria de Pedidos Designados'
  },
  auditIntro: {
    zh: '客服上传待审核单号后，系统先校验运单是否存在、是否已签收以及是否存在POD；仅满足条件的单号进入正式POD审核。',
    en: 'After customer service uploads waybills pending audit, the system first verifies whether the waybill exists, whether it has been signed, and whether a POD exists; only qualified waybills enter the formal POD audit.',
    pu: 'Após o atendimento enviar os pedidos pendentes de auditoria, o sistema verifica se o pedido existe, se foi assinado e se há POD; apenas os pedidos que atendem aos critérios entram na auditoria formal de POD.'
  },
  uploadTitle: {
    zh: '上传待审核单号',
    en: 'Upload Waybills Pending Audit',
    pu: 'Enviar Pedidos Pendentes de Auditoria'
  },
  uploadDesc: {
    zh: '支持 XLSX / XLS / CSV；仅识别第一列运单号；单次最多 5,000 个。文件选择完成后自动进行预提交校验。',
    en: 'Supports XLSX / XLS / CSV; only the first column of waybill numbers is recognized; up to 5,000 per upload. Pre-submit validation runs automatically after file selection.',
    pu: 'Suporta XLSX / XLS / CSV; apenas a primeira coluna de números de pedido é reconhecida; máximo de 5.000 por envio. A validação prévia é executada automaticamente após selecionar o arquivo.'
  },
  downloadTemplate: {
    zh: '下载模板',
    en: 'Download Template',
    pu: 'Baixar Modelo'
  },
  selectFile: {
    zh: '选择文件',
    en: 'Select File',
    pu: 'Selecionar Arquivo'
  },
  fileReadTip: {
    zh: '文件已读取，系统将自动进行预提交校验',
    en: 'File loaded, the system will run pre-submit validation automatically',
    pu: 'Arquivo carregado, o sistema executará a validação prévia automaticamente'
  },
  reselect: {
    zh: '重新选择',
    en: 'Reselect',
    pu: 'Selecionar Novamente'
  },
  precheckResult: {
    zh: '预提交校验结果',
    en: 'Pre-submit Validation Result',
    pu: 'Resultado da Validação Prévia'
  },
  precheckTip: {
    zh: '仅“可审核”单号会进入正式POD审核任务',
    en: 'Only "auditable" waybills enter the formal POD audit task',
    pu: 'Apenas pedidos "auditáveis" entram na tarefa formal de auditoria de POD'
  },
  auditable: {
    zh: '可审核',
    en: 'Auditable',
    pu: 'Auditável'
  },
  notSigned: {
    zh: '未签收',
    en: 'Not Signed',
    pu: 'Não Assinado'
  },
  signedNoPod: {
    zh: '已签收但无POD',
    en: 'Signed but No POD',
    pu: 'Assinado mas Sem POD'
  },
  notExist: {
    zh: '运单不存在',
    en: 'Waybill Not Found',
    pu: 'Pedido Não Encontrado'
  },
  duplicate: {
    zh: '重复单号',
    en: 'Duplicate Waybill',
    pu: 'Pedido Duplicado'
  },
  exportPrecheck: {
    zh: '导出校验明细',
    en: 'Export Validation Details',
    pu: 'Exportar Detalhes da Validação'
  },
  submitting: {
    zh: '提交中...',
    en: 'Submitting...',
    pu: 'Enviando...'
  },
  startAuditCount: {
    zh: '开始审核（{count}）',
    en: 'Start Audit ({count})',
    pu: 'Iniciar Auditoria ({count})'
  },
  auditTask: {
    zh: '审核任务',
    en: 'Audit Tasks',
    pu: 'Tarefas de Auditoria'
  },
  taskNo: {
    zh: '任务编号',
    en: 'Task No.',
    pu: 'Nº da Tarefa'
  },
  inputTaskNo: {
    zh: '请输入任务编号',
    en: 'Please enter task No.',
    pu: 'Por favor insira o nº da tarefa'
  },
  taskStatus: {
    zh: '任务状态',
    en: 'Task Status',
    pu: 'Status da Tarefa'
  },
  all: {
    zh: '全部',
    en: 'All',
    pu: 'Todos'
  },
  auditing: {
    zh: '审核中',
    en: 'Auditing',
    pu: 'Em Auditoria'
  },
  completed: {
    zh: '已完成',
    en: 'Completed',
    pu: 'Concluído'
  },
  search: {
    zh: '搜索',
    en: 'Search',
    pu: 'Pesquisar'
  },
  reset: {
    zh: '重置',
    en: 'Reset',
    pu: 'Redefinir'
  },
  uploadTime: {
    zh: '上传时间',
    en: 'Upload Time',
    pu: 'Hora do Upload'
  },
  uploadCount: {
    zh: '上传单号',
    en: 'Uploaded Waybills',
    pu: 'Pedidos Enviados'
  },
  auditedCount: {
    zh: '已审核',
    en: 'Audited',
    pu: 'Auditados'
  },
  auditProgress: {
    zh: '审核进度',
    en: 'Audit Progress',
    pu: 'Progresso da Auditoria'
  },
  operation: {
    zh: '操作',
    en: 'Operation',
    pu: 'Operação'
  },
  viewResult: {
    zh: '查看结果',
    en: 'View Result',
    pu: 'Ver Resultado'
  },
  export: {
    zh: '导出',
    en: 'Export',
    pu: 'Exportar'
  },
  auditResultTitle: {
    zh: '审核结果',
    en: 'Audit Result',
    pu: 'Resultado da Auditoria'
  },
  taskNoLabel: {
    zh: '任务编号：',
    en: 'Task No.: ',
    pu: 'Nº da Tarefa: '
  },
  searchWaybill: {
    zh: '搜索运单号',
    en: 'Search Waybill No.',
    pu: 'Pesquisar Nº do Pedido'
  },
  allResult: {
    zh: '全部结果',
    en: 'All Results',
    pu: 'Todos os Resultados'
  },
  qualified: {
    zh: '合格',
    en: 'Qualified',
    pu: 'Qualificado'
  },
  unqualified: {
    zh: '不合格',
    en: 'Unqualified',
    pu: 'Não Qualificado'
  },
  pending: {
    zh: '待审核',
    en: 'Pending',
    pu: 'Pendente'
  },
  exportAuditResult: {
    zh: '导出审核结果',
    en: 'Export Audit Result',
    pu: 'Exportar Resultado da Auditoria'
  },
  waybillNumber: {
    zh: '运单号',
    en: 'Waybill No.',
    pu: 'Nº do Pedido'
  },
  signatureResult: {
    zh: '签名结果',
    en: 'Signature Result',
    pu: 'Resultado da Assinatura'
  },
  photoResult: {
    zh: '图片结果',
    en: 'Photo Result',
    pu: 'Resultado da Imagem'
  },
  totalResult: {
    zh: '审核结果',
    en: 'Audit Result',
    pu: 'Resultado da Auditoria'
  },
  failReason: {
    zh: '不通过原因',
    en: 'Rejection Reason',
    pu: 'Motivo da Reprovação'
  },
  auditTime: {
    zh: '审核时间',
    en: 'Audit Time',
    pu: 'Hora da Auditoria'
  },
  detail: {
    zh: '详情',
    en: 'Details',
    pu: 'Detalhes'
  },
  totalRecords: {
    zh: '共 {count} 条',
    en: '{count} records in total',
    pu: '{count} registros no total'
  },
  detailTitle: {
    zh: 'POD审核详情',
    en: 'POD Audit Details',
    pu: 'Detalhes da Auditoria de POD'
  },
  signatureFailReason: {
    zh: '签名不通过原因',
    en: 'Signature Rejection Reason',
    pu: 'Motivo da Reprovação da Assinatura'
  },
  photoFailReason: {
    zh: '图片不通过原因',
    en: 'Photo Rejection Reason',
    pu: 'Motivo da Reprovação da Imagem'
  },
  close: {
    zh: '关闭',
    en: 'Close',
    pu: 'Fechar'
  },
  taskCreated: {
    zh: '审核任务已创建',
    en: 'Audit task created',
    pu: 'Tarefa de auditoria criada'
  },
  taskCreatedDesc: {
    zh: '已提交 {count} 个可审核单号，可在下方「审核任务」中查看审核进度。',
    en: 'Submitted {count} auditable waybills. You can view the audit progress in "Audit Tasks" below.',
    pu: 'Enviados {count} pedidos auditáveis. Você pode ver o progresso da auditoria em "Tarefas de Auditoria" abaixo.'
  },
  waitPrecheck: {
    zh: '等待预提交校验',
    en: 'Waiting for pre-submit validation',
    pu: 'Aguardando validação prévia'
  },
  prechecking: {
    zh: '预提交校验中...',
    en: 'Pre-submit validating...',
    pu: 'Validando pré-envio...'
  },
  precheckDone: {
    zh: '预提交校验完成',
    en: 'Pre-submit validation completed',
    pu: 'Validação prévia concluída'
  },
  precheckFailed: {
    zh: '预提交校验失败',
    en: 'Pre-submit validation failed',
    pu: 'Falha na validação prévia'
  },
  noTaskIdView: {
    zh: '任务ID不存在，无法查看审核结果',
    en: 'Task ID not found, cannot view audit result',
    pu: 'ID da tarefa não encontrado, não é possível ver o resultado da auditoria'
  },
  noTaskIdExport: {
    zh: '任务ID不存在，无法导出',
    en: 'Task ID not found, cannot export',
    pu: 'ID da tarefa não encontrado, não é possível exportar'
  },
  templateFileName: {
    zh: 'POD指定审核导入模板.csv',
    en: 'POD_Designated_Audit_Import_Template.csv',
    pu: 'Modelo_Importacao_Auditoria_POD.csv'
  },
  signaturePrefix: {
    zh: '签名：',
    en: 'Signature: ',
    pu: 'Assinatura: '
  },
  photoPrefix: {
    zh: '图片：',
    en: 'Photo: ',
    pu: 'Imagem: '
  },
  reasonSeparator: {
    zh: '；',
    en: '; ',
    pu: '; '
  },
  dash: {
    zh: '-',
    en: '-',
    pu: '-'
  }
};

export { login, podVerification };
